/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * API For public part of application: Inzerce nemovitého majetku
 * This API provides endpoints for public part: Inzerce nemovitého majetku
 * OpenAPI spec version: v1
 */
/**
 * Enum AdvertisementSort
 */
export type AdvertisementSort = (typeof AdvertisementSort)[keyof typeof AdvertisementSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdvertisementSort = {
	Newest: "Newest",
	Oldest: "Oldest",
	AlphabeticalAsc: "AlphabeticalAsc",
	AlphabeticalDesc: "AlphabeticalDesc",
	Cheapest: "Cheapest",
	MostExpensive: "MostExpensive",
	ExpirationAsc: "ExpirationAsc",
	ExpirationDesc: "ExpirationDesc",
} as const;

/**
 * Class RealEstateAttributeList.
 */
export interface AssetAttributeList {
	/**
	 * Gets or sets the data.
	 * @nullable
	 */
	data?: AssetAttributeListItem[] | null;
}

/**
 * Class AssetAttributeListItem.
 */
export interface AssetAttributeListItem {
	name: AssetAttributeName;
	type: AttributeType;
	/** |
            Gets or sets a value indicating whether this instance is required. */
	isRequired: boolean;
	/** Gets or sets a value indicating whether this AdFrameApi.API.DataContracts.Assets.Responses.AssetAttributeListItem is filter. */
	filter: boolean;
	/** Gets or sets the default dropdown values. */
	defaultDropdownValues: string[];
	/** Gets or sets a value indicating whether this AdFrameApi.API.DataContracts.Assets.Responses.AssetAttributeListItem is checked. */
	checked: boolean;
	/** Gets or sets a value indicating whether this AdFrameApi.API.DataContracts.Assets.Responses.AssetAttributeListItem is filter. */
	showInMainFilter?: boolean;
	/** Gets or sets a value indicating whether this AdFrameApi.API.DataContracts.Assets.Responses.AssetAttributeListItem is shown in pdf generated. */
	showInPdf?: boolean;
	/**
	 * User friendly text for specific param
	 * @nullable
	 */
	readonly displayLabel?: string | null;
}

/**
 * Enum AttributeName
 */
export type AssetAttributeName = (typeof AssetAttributeName)[keyof typeof AssetAttributeName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetAttributeName = {
	Druh: "Druh",
	Znacka: "Znacka",
	Model: "Model",
	RokUvedeniDoProvozu: "RokUvedeniDoProvozu",
	NajeteKilometry: "NajeteKilometry",
	ObjemMotoru: "ObjemMotoru",
	Vykon: "Vykon",
	Karoserie: "Karoserie",
	Prevodovka: "Prevodovka",
	Palivo: "Palivo",
	Stk: "Stk",
	Bourane: "Bourane",
	OdpocetDph: "OdpocetDph",
	ServisniKnizka: "ServisniKnizka",
	Spotreba: "Spotreba",
	Pohon: "Pohon",
	MistKSezeni: "MistKSezeni",
	Klimatizace: "Klimatizace",
	TazneZarizeni: "TazneZarizeni",
	Barva: "Barva",
	Tempomat: "Tempomat",
	Navigace: "Navigace",
	ParkovaciKamera: "ParkovaciKamera",
	ParkovaciSenzory: "ParkovaciSenzory",
	PocetAirbagu: "PocetAirbagu",
	Autoradio: "Autoradio",
	BezklickoveOdemykani: "BezklickoveOdemykani",
	Bluetooth: "Bluetooth",
	StopStartSystem: "StopStartSystem",
	MultifunkcniVolant: "MultifunkcniVolant",
	AsistentRozjeduDoKopce: "AsistentRozjeduDoKopce",
	HlidaniJiznichPruhu: "HlidaniJiznichPruhu",
	HlidaniMrtvehoUhlu: "HlidaniMrtvehoUhlu",
	TypVozidla: "TypVozidla",
	RokVyroby: "RokVyroby",
	TypMotoru: "TypMotoru",
	PocetNaprav: "PocetNaprav",
	PocetHnacichNaprav: "PocetHnacichNaprav",
	Vyrobce: "Vyrobce",
	DobaProvozu: "DobaProvozu",
	StavOpotrebeni: "StavOpotrebeni",
	Hmotnost: "Hmotnost",
	Delka: "Delka",
	MaximalniRychlost: "MaximalniRychlost",
	Rozchod: "Rozchod",
	PlatnostTechnickeProhlidky: "PlatnostTechnickeProhlidky",
	KompatibilitaSInfrastrukturou: "KompatibilitaSInfrastrukturou",
	TypBrzd: "TypBrzd",
	TypNarazecihoUstroji: "TypNarazecihoUstroji",
	PrenosVykonu: "PrenosVykonu",
	Kapacita: "Kapacita",
	ZpusobChlazeniMotoru: "ZpusobChlazeniMotoru",
	BezpecnostniVybaveni: "BezpecnostniVybaveni",
	HistorieNehod: "HistorieNehod",
	Vysilacka: "Vysilacka",
	SledovaniSpotreby: "SledovaniSpotreby",
	VyrobniCislo: "VyrobniCislo",
	StavMotoru: "StavMotoru",
	StavBrzd: "StavBrzd",
	StavNaprav: "StavNaprav",
	StavPodvozku: "StavPodvozku",
	VelikostPametiRam: "VelikostPametiRam",
	VelikostDispleje: "VelikostDispleje",
	PocetMegapixeluFotoaparatu: "PocetMegapixeluFotoaparatu",
	OperacniSystem: "OperacniSystem",
	DatumZakoupeni: "DatumZakoupeni",
	RozliseniDispleje: "RozliseniDispleje",
	TypDispleje: "TypDispleje",
	TypProcesoru: "TypProcesoru",
	KapacitaBaterie: "KapacitaBaterie",
	PocetMegapixeluPredniFotoaparatu: "PocetMegapixeluPredniFotoaparatu",
	Nabijecka: "Nabijecka",
	Sluchatka: "Sluchatka",
	PropojovaciKabel: "PropojovaciKabel",
	OchrannePouzdro: "OchrannePouzdro",
	OchranneSklo: "OchranneSklo",
	ServisAOpravy: "ServisAOpravy",
	OdblokovaniProVsechnySite: "OdblokovaniProVsechnySite",
	NefungujiciSoucasti: "NefungujiciSoucasti",
	KapacitaUloziste: "KapacitaUloziste",
	PocetJaderProcesoru: "PocetJaderProcesoru",
	VyrobceGrafickeKarty: "VyrobceGrafickeKarty",
	VelikostPametiVga: "VelikostPametiVga",
	TypPametiRam: "TypPametiRam",
	RozliseniWebkamery: "RozliseniWebkamery",
	TypBaterie: "TypBaterie",
	MaterialKonstrukce: "MaterialKonstrukce",
	SitovePripojeni: "SitovePripojeni",
	DatoveRozhrani: "DatoveRozhrani",
	GrafickyVystup: "GrafickyVystup",
	AudioVystup: "AudioVystup",
	WiFi: "WiFi",
	Abs: "Abs",
	Esp: "Esp",
	Isofix: "Isofix",
	Sirka: "Sirka",
	Vyska: "Vyska",
	NabijeciKonektor: "NabijeciKonektor",
	RozpoznaniObliceje: "RozpoznaniObliceje",
	PocetSim: "PocetSim",
	HmotnostZarizeni: "HmotnostZarizeni",
	BezdratoveNabijeni: "BezdratoveNabijeni",
	DatumVyroby: "DatumVyroby",
	Prohlidky: "Prohlidky",
	Revize: "Revize",
	PlatnaTechnickaKontrola: "PlatnaTechnickaKontrola",
	DalsiInformace: "DalsiInformace",
} as const;

/**
 * Represents various categories of assets that can be classified within the system.
 */
export type AssetCategoryType = (typeof AssetCategoryType)[keyof typeof AssetCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetCategoryType = {
	Undefined: "Undefined",
	PersonalVehicles: "PersonalVehicles",
	CommericalVehicles: "CommericalVehicles",
	RailwayVehicles: "RailwayVehicles",
	Collectables: "Collectables",
	Computers: "Computers",
	Phones: "Phones",
	Other: "Other",
	Electronics: "Electronics",
} as const;

/**
 * Class AssetIFrameCategoryDto.
 */
export interface AssetIFrameCategoryDto {
	/** Gets or sets the identifier. */
	id: number;
	/**
	 * Gets or sets the name.
	 * @minLength 1
	 */
	name: string;
	assetCategoryType: AssetCategoryType;
	/** Gets or sets the attributes. */
	attributes: AssetAttributeName[];
	/** Gets or sets the main filter attributes. */
	mainFilterAttributes: AssetAttributeName[];
}

/**
 * Default collection used for paginated responses
 */
export interface AssetIFrameCategoryDtoPaginatedCollection {
	/**
	 * List of data on page
	 * @nullable
	 */
	data?: AssetIFrameCategoryDto[] | null;
	/** Requested page number */
	page?: number;
	/** True page size (can be lower than requested) */
	pageSize?: number;
	/** Requested page size */
	readonly requestedPageSize?: number;
	/** Total records in collection before pagination */
	totalRecords?: number;
	/** Total pages in collection before pagination */
	readonly totalPages?: number;
	/**
	 * Requested filter
	 * @nullable
	 */
	filter?: string | null;
	/**
	 * Requested sort
	 * @nullable
	 */
	sort?: string | null;
}

/**
 * Dto for AdFrameApi.Domain.Models.Assets.AssetsAdvertAttributes
 */
export interface AssetsAdvertAttributesDto {
	/** Id inzerátu */
	id?: number;
	/** Vytvořeno dne */
	createdAt?: string;
	/** Upraveno dne */
	updatedAt?: string;
	/** Id inzerátu */
	assetsAdvertId?: number;
	/**
	 * Stores the vehicle type (osobní/dodávkové).
	 * @nullable
	 */
	druh?: string | null;
	/**
	 * Stores the vehicle brand (napříkad: FORD).
	 * @nullable
	 */
	znacka?: string | null;
	/**
	 * Stores the vehicle model (napříkad: S-MAX).
	 * @nullable
	 */
	model?: string | null;
	/**
	 * Stores the year of first use (Rok uvedení do provozu).
	 * @nullable
	 */
	rokUvedeniDoProvozu?: string | null;
	/** Stores the mileage in kilometers (Najeté kilometry). */
	najeteKilometry?: number;
	/** Stores the engine displacement (Objem motoru). */
	objemMotoru?: number;
	/** Stores the engine power (Výkon). */
	vykon?: number;
	/**
	 * Stores the body type (Karoserie), napříkad: sedan, kombu, hatchback, SUV, MPV, VAN, jiné.
	 * @nullable
	 */
	karoserie?: string | null;
	/**
	 * Stores the transmission type (Převodovka), napříkad: Manuál, automat + počet stupňů.
	 * @nullable
	 */
	prevodovka?: string | null;
	/**
	 * Stores the fuel type (Palivo), napříkad: Benzín, nafta, Elektro, hybrid, LPGT, CNG, jiné.
	 * @nullable
	 */
	palivo?: string | null;
	/**
	 * Stores the technical inspection expiry date (STK), napříkad: 12/2024.
	 * @nullable
	 */
	stk?: string | null;
	/**
	 * Indicates whether the vehicle has been in an accident (Bourané).
	 * @nullable
	 */
	bourane?: boolean | null;
	/**
	 * Indicates whether VAT is deductible (Odpočet DPH).
	 * @nullable
	 */
	odpocetDph?: boolean | null;
	/**
	 * Indicates whether the vehicle comes with a service book (Servisní knížka).
	 * @nullable
	 */
	servisniKnizka?: boolean | null;
	/**
	 * Stores the fuel consumption options (Spotřeba), napříkad: 7,5; 5,6; 6,0.
	 * @nullable
	 */
	spotreba?: string | null;
	/**
	 * Stores the drive type (Pohon), napříkad: přední, zadní, 4x4.
	 * @nullable
	 */
	pohon?: string | null;
	/** Stores the number of seats (Míst k sezení). */
	mistKSezeni?: number;
	/**
	 * Indicates whether the vehicle has air conditioning (Klimatizace).
	 * @nullable
	 */
	klimatizace?: boolean | null;
	/**
	 * Indicates whether the vehicle is equipped with a tow bar (Tažné zařízení).
	 * @nullable
	 */
	tazneZarizeni?: boolean | null;
	/**
	 * Stores the vehicle color (Barva).
	 * @nullable
	 */
	barva?: string | null;
	/**
	 * Indicates whether the vehicle is equipped with cruise control (Tempomat).
	 * @nullable
	 */
	tempomat?: boolean | null;
	/**
	 * Indicates whether the vehicle has a navigation system (Navigace).
	 * @nullable
	 */
	navigace?: boolean | null;
	/**
	 * Indicates whether the vehicle is equipped with a parking camera (Parkovací kamera).
	 * @nullable
	 */
	parkovaciKamera?: boolean | null;
	/**
	 * Indicates whether the vehicle is equipped with parking sensors (Parkovací senzory).
	 * @nullable
	 */
	parkovaciSenzory?: boolean | null;
	/**
	 * Indicates whether the vehicle has airbags (Počet airbagů).
	 * @nullable
	 */
	pocetAirbagu?: number | null;
	/**
	 * Indicates whether the vehicle is equipped with a car stereo (Autorádio).
	 * @nullable
	 */
	autoradio?: boolean | null;
	/**
	 * Indicates whether the vehicle has keyless entry (Bezklíčkové odemykání).
	 * @nullable
	 */
	bezklickoveOdemykani?: boolean | null;
	/**
	 * Indicates whether the vehicle supports Bluetooth connectivity (Bluetooth připojení).
	 * @nullable
	 */
	bluetooth?: boolean | null;
	/**
	 * Indicates whether the vehicle is equipped with a stop-start system (Stop Start systém).
	 * @nullable
	 */
	stopStartSystem?: boolean | null;
	/**
	 * Indicates whether the vehicle is equipped with a multifunction steering wheel (Multifunkční volat).
	 * @nullable
	 */
	multifunkcniVolant?: boolean | null;
	/**
	 * Indicates whether the vehicle has hill-start assist (Asistent rozjedu do kopce).
	 * @nullable
	 */
	asistentRozjeduDoKopce?: boolean | null;
	/**
	 * Indicates whether the vehicle is equipped with lane departure warning (Hlídání jízních průhů).
	 * @nullable
	 */
	hlidaniJiznichPruhu?: boolean | null;
	/**
	 * Indicates whether the vehicle has blind spot monitoring (Hlídání mrtvého úhlu).
	 * @nullable
	 */
	hlidaniMrtvehoUhlu?: boolean | null;
	/**
	 * Indicates whether the vehicle has Abs
	 * @nullable
	 */
	abs?: boolean | null;
	/**
	 * Indicates whether the vehicle has Esp
	 * @nullable
	 */
	esp?: boolean | null;
	/**
	 * Indicates whether the vehicle has Isofix
	 * @nullable
	 */
	isofix?: boolean | null;
	/**
	 * Stores a descriptive vehicle type (Typ vozidla).
	 * @nullable
	 */
	typVozidla?: string | null;
	/**
	 * Stores the year of manufacture (Rok výroby).
	 * @nullable
	 */
	rokVyroby?: string | null;
	/**
	 * Stores the engine type (Typ motoru).
	 * @nullable
	 */
	typMotoru?: string | null;
	/** Stores the number of axles (Počet náprav). */
	pocetNaprav?: number;
	/** Stores the number of driven axles (Počet hnacích náprav). */
	pocetHnacichNaprav?: number;
	/**
	 * Stores the manufacturer (Výrobce).
	 * @nullable
	 */
	vyrobce?: string | null;
	/**
	 * Stores the period of operation (Doba provozu).
	 * @nullable
	 */
	dobaProvozu?: string | null;
	/**
	 * Stores the wear condition (Stav opotřebení).
	 * @nullable
	 */
	stavOpotrebeni?: string | null;
	/** Stores the weight (Hmotnost). */
	hmotnost?: number;
	/** Stores the length (Délka). */
	delka?: number;
	/** Stores the maximum speed (Maximální rychlost). */
	maximalniRychlost?: number;
	/** Stores the wheel track (Rozchod). */
	rozchod?: number;
	/**
	 * Stores the expiry date of the technical inspection (Platnost technické prohlídky a revizíí).
	 * @nullable
	 */
	platnostTechnickeProhlidky?: string | null;
	/**
	 * Stores the infrastructure compatibility (Kompatibilita s infrastrukturou), napříkad: elektrifikované, neelektrifikované, vysokorychlostní.
	 * @nullable
	 */
	kompatibilitaSInfrastrukturou?: string | null;
	/**
	 * Stores the type of brakes (Typ brzd).
	 * @nullable
	 */
	typBrzd?: string | null;
	/**
	 * Stores the type of impact system (Typ naražecího ústrojí).
	 * @nullable
	 */
	typNarazecihoUstroji?: string | null;
	/**
	 * Stores the power transfer system (Přenos výkonu).
	 * @nullable
	 */
	prenosVykonu?: string | null;
	/**
	 * Stores the capacity (Kapacita) for load or passengers.
	 * @nullable
	 */
	kapacita?: string | null;
	/**
	 * Stores the engine cooling method (Způsob chlazení motoru).
	 * @nullable
	 */
	zpusobChlazeniMotoru?: string | null;
	/**
	 * Stores information about safety equipment (Bezpečnostní vybavení).
	 * @nullable
	 */
	bezpecnostniVybaveni?: string | null;
	/**
	 * Stores the accident history (Historie nehod).
	 * @nullable
	 */
	historieNehod?: string | null;
	/**
	 * Indicates whether the vehicle is equipped with a transceiver (Vysílačka).
	 * @nullable
	 */
	vysilacka?: boolean | null;
	/**
	 * Stores information about consumption monitoring (Sledování spotřeby).
	 * @nullable
	 */
	sledovaniSpotreby?: string | null;
	/**
	 * Stores the production serial number (Výrobní číslo).
	 * @nullable
	 */
	vyrobniCislo?: string | null;
	/**
	 * Stores the engine condition (Stav motoru).
	 * @nullable
	 */
	stavMotoru?: string | null;
	/**
	 * Stores the brake condition (Stav brzd).
	 * @nullable
	 */
	stavBrzd?: string | null;
	/**
	 * Stores the condition of the axles (Stav náprav).
	 * @nullable
	 */
	stavNaprav?: string | null;
	/**
	 * Stores the condition of the chassis (Stav podvozku).
	 * @nullable
	 */
	stavPodvozku?: string | null;
	/** Stores the size of the RAM (Velikost paměti RAM) in GB. */
	velikostPametiRam?: number;
	/** Stores the display size (Velikost displeje) in inches or centimeters. */
	velikostDispleje?: number;
	/** Stores the number of megapixels of the rear camera (Počet megapixelů fotoaparátu). */
	pocetMegapixeluFotoaparatu?: number;
	/**
	 * Stores the operating system (Operační systém).
	 * @nullable
	 */
	operacniSystem?: string | null;
	/**
	 * Stores the purchase date (Datum zakoupení).
	 * @nullable
	 */
	datumZakoupeni?: string | null;
	/**
	 * Stores the display resolution (Rozlišení displeje), napříkad: "1920x1080".
	 * @nullable
	 */
	rozliseniDispleje?: string | null;
	/**
	 * Stores the type of display (Typ displeje).
	 * @nullable
	 */
	typDispleje?: string | null;
	/**
	 * Stores the processor type (Typ procesoru).
	 * @nullable
	 */
	typProcesoru?: string | null;
	/** Stores the battery capacity (Kapacita baterie) in mAh. */
	kapacitaBaterie?: number;
	/** Stores the number of megapixels of the front camera (Počet megapixelů předního fotoaparátu). */
	pocetMegapixeluPredniFotoaparatu?: number;
	/**
	 * Indicates whether a charger is included (Nabíječka).
	 * @nullable
	 */
	nabijecka?: boolean | null;
	/**
	 * Indicates whether headphones are included (Sluchátka).
	 * @nullable
	 */
	sluchatka?: boolean | null;
	/**
	 * Indicates whether a connecting cable is included (Propjovací kabel).
	 * @nullable
	 */
	propojovaciKabel?: boolean | null;
	/**
	 * Indicates whether a protective case is included (Ochranné pouzdro).
	 * @nullable
	 */
	ochrannePouzdro?: boolean | null;
	/**
	 * Indicates whether protective glass is included (Ochranné sklo).
	 * @nullable
	 */
	ochranneSklo?: boolean | null;
	/**
	 * Stores details about service and repairs (Servis a opravy).
	 * @nullable
	 */
	servisAOpravy?: string | null;
	/**
	 * Indicates whether the device is unlocked for all networks (Odblokovaní pro všechny sítě).
	 * @nullable
	 */
	odblokovaniProVsechnySite?: boolean | null;
	/**
	 * Stores information about non-functioning components (Nefungující součásti).
	 * @nullable
	 */
	nefungujiciSoucasti?: string | null;
	/** Stores the storage capacity (Kapacita úložiště) in GB. */
	kapacitaUloziste?: number;
	/** Stores the number of processor cores (Počet jader procesoru). */
	pocetJaderProcesoru?: number;
	/**
	 * Stores the graphics card manufacturer (Výrobce grafické karty).
	 * @nullable
	 */
	vyrobceGrafickeKarty?: string | null;
	/** Stores the VGA memory size (Velikost paměti VGA) in MB. */
	velikostPametiVga?: number;
	/**
	 * Stores the type of RAM (Typ paměti RAM).
	 * @nullable
	 */
	typPametiRam?: string | null;
	/**
	 * Stores the resolution of the webcam (Rozlišení webkamery).
	 * @nullable
	 */
	rozliseniWebkamery?: string | null;
	/**
	 * Stores the battery type (Typ baterie).
	 * @nullable
	 */
	typBaterie?: string | null;
	/**
	 * Stores the construction material (Materiál konstrukce).
	 * @nullable
	 */
	materialKonstrukce?: string | null;
	/**
	 * Stores the type of wired connectivity (Sítové připojení).
	 * @nullable
	 */
	sitovePripojeni?: string | null;
	/**
	 * Stores the data interface (Datové rozhraní).
	 * @nullable
	 */
	datoveRozhrani?: string | null;
	/**
	 * Stores the graphics output (Grafický výstup).
	 * @nullable
	 */
	grafickyVystup?: string | null;
	/**
	 * Stores the audio output (Audio výstup).
	 * @nullable
	 */
	audioVystup?: string | null;
	/**
	 * Indicates whether the device supports Wi-Fi connectivity (Wi‑Fi).
	 * @nullable
	 */
	wiFi?: boolean | null;
	/** Stores the width */
	sirka?: number;
	/** Stores the height */
	vyska?: number;
	/**
	 * Stores the type of charging port
	 * @nullable
	 */
	nabijeciKonektor?: string | null;
	/**
	 * Indicates whether the device supports Wi-Fi connectivity (Wi‑Fi).
	 * @nullable
	 */
	rozpoznaniObliceje?: boolean | null;
	/**
	 * Stores the number of sim cards in devices and type of the sim cards (eSIM and micro SIM)
	 * @nullable
	 */
	pocetSim?: string | null;
	/**
	 * Stores the weight of the device
	 * @nullable
	 */
	hmotnostZarizeni?: number | null;
	/**
	 * Stores if the device has wireless charging (yes/no)
	 * @nullable
	 */
	bezdratoveNabijeni?: boolean | null;
	/**
   * Stores the Month and Year of manufacture
///
   * @nullable
   */
	datumVyroby?: string | null;
	/**
   * Stores the Month and Year of Prohlidky
///
   * @nullable
   */
	prohlidky?: string | null;
	/**
   * Stores the Month and Year of Revize
///
   * @nullable
   */
	revize?: string | null;
	/**
	 * Indicates whether the thing has valid technical control.
	 * @nullable
	 */
	platnaTechnickaKontrola?: boolean | null;
	/**
	 * Stores additional information
	 * @nullable
	 */
	dalsiInformace?: string | null;
}

/**
 * Represents basic information about an advertisement group.

Contains the group's unique identifier and its display name.
 */
export interface AssetsAdvertGroupRowDetail {
	/** Gets or sets the unique identifier of the assetsAdvert. */
	id: number;
	/**
	 * Gets or sets the name of the assetsAdvert .
	 * @minLength 1
	 */
	name: string;
}

/**
 * Enum AttributeType
 */
export type AttributeType = (typeof AttributeType)[keyof typeof AttributeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttributeType = {
	Integer: "Integer",
	Double: "Double",
	ShortString: "ShortString",
	LongString: "LongString",
	DateFull: "DateFull",
	Boolean: "Boolean",
	DateRange: "DateRange",
	Dropdown: "Dropdown",
	DateYear: "DateYear",
	DateMonth: "DateMonth",
} as const;

/**
 * Class ClientError.
 */
export interface ClientError {
	/**
	 * Gets or sets the type.
	 * @minLength 1
	 */
	type: string;
	/**
	 * Gets or sets the message.
	 * @minLength 1
	 */
	message: string;
	/** Gets or sets the code. */
	code: number;
	/** Gets or sets the time stamp. */
	timeStamp: string;
}

export interface FileItemDto {
	id?: number;
	/** @nullable */
	description?: string | null;
	/** @nullable */
	fileName?: string | null;
	order?: number;
	/** @nullable */
	extension?: string | null;
}

export interface GalleryItemDto {
	id?: number;
	/** @nullable */
	imageUrl?: string | null;
	/** @nullable */
	description?: string | null;
	/** @nullable */
	fileName?: string | null;
	size?: bigint;
	order?: number;
}

/**
 * Class IFrameAdvertisementDto.
 */
export interface IFrameAssetsAdvertDto {
	/** Gets or sets the identifier. */
	id: number;
	/** Gets or sets the created at. */
	createdAt: string;
	/** Gets or sets the updated at. */
	updatedAt: string;
	/**
	 * Gets or sets the name.
	 * @minLength 1
	 */
	name: string;
	/**
	 * Gets or sets the description.
	 * @nullable
	 */
	description?: string | null;
	/**
	 * Gets or sets the district identifier.
	 * @nullable
	 */
	districtId?: number | null;
	/**
	 * Gets or sets the directorate identifier.
	 * @nullable
	 */
	directorateId?: number | null;
	/** Gets or sets the region identifier. */
	regionId: number;
	/** Gets or sets the assets category identifier. */
	assetsCategoryId: number;
	/**
	 * Gets or sets the real estate category.
	 * @minLength 1
	 */
	assetsCategory: string;
	/**
	 * Gets or sets the district.
	 * @nullable
	 */
	district?: string | null;
	/**
	 * Gets or sets the region.
	 * @minLength 1
	 */
	region: string;
	/** Gets or sets the price. */
	price: number;
	/** Gets or sets a value indicating whether [show price]. */
	showPrice: boolean;
	/** Gets or sets the publish from. */
	publishFrom: string;
	/**
	 * Gets or sets the publish to.
	 * @nullable
	 */
	publishTo?: string | null;
	state: State;
	/**
	 * Gets or sets the contact forename.
	 * @nullable
	 */
	contactForename?: string | null;
	/**
	 * Gets or sets the contact surname.
	 * @nullable
	 */
	contactSurname?: string | null;
	/**
	 * Gets or sets the contact email.
	 * @nullable
	 */
	contactEmail?: string | null;
	/**
	 * Gets or sets the contact phone.
	 * @nullable
	 */
	contactPhone?: string | null;
	attributes: AssetsAdvertAttributesDto;
	/**
   * Provides details about the group of advertisements associated with this N:AdFrameApi.API.DataContracts.Assets.Entity.AssetsAdvert.

- If this property is `null`, the N:AdFrameApi.API.DataContracts.Assets.Entity.AssetsAdvert does not belong to any N:AdFrameApi.API.DataContracts.Assets.Entity.AdvertGroup.
- If this property is not `null`, there are additional published advertisements that belong to the same N:AdFrameApi.API.DataContracts.Assets.Entity.AdvertGroup.

Contains a list of AdFrameApi.API.DataContracts.Assets.Entity.AssetsAdvert.IFrameAssetsAdvertDto.AssetsAdvertGroupRowDetail representing the related group entries that match public filter.
   * @nullable
   */
	assetsAdvertGroupRowDetail?: AssetsAdvertGroupRowDetail[] | null;
	priceType: PriceType;
}

/**
 * Default collection used for paginated responses
 */
export interface IFrameAssetsAdvertDtoPaginatedCollection {
	/**
	 * List of data on page
	 * @nullable
	 */
	data?: IFrameAssetsAdvertDto[] | null;
	/** Requested page number */
	page?: number;
	/** True page size (can be lower than requested) */
	pageSize?: number;
	/** Requested page size */
	readonly requestedPageSize?: number;
	/** Total records in collection before pagination */
	totalRecords?: number;
	/** Total pages in collection before pagination */
	readonly totalPages?: number;
	/**
	 * Requested filter
	 * @nullable
	 */
	filter?: string | null;
	/**
	 * Requested sort
	 * @nullable
	 */
	sort?: string | null;
}

/**
 * Enum for choice wich price is it
 */
export type PriceType = (typeof PriceType)[keyof typeof PriceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceType = {
	AskingPrice: "AskingPrice",
	Price: "Price",
} as const;

export interface ProblemDetails {
	/** @nullable */
	type?: string | null;
	/** @nullable */
	title?: string | null;
	/** @nullable */
	status?: number | null;
	/** @nullable */
	detail?: string | null;
	/** @nullable */
	instance?: string | null;
	[key: string]: unknown;
}

/**
 * Enum State
 */
export type State = (typeof State)[keyof typeof State];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const State = {
	Created: "Created",
	WaitingForApproval: "WaitingForApproval",
	SentBack: "SentBack",
	WaitingForPublish: "WaitingForPublish",
	Published: "Published",
	Finished: "Finished",
	Canceled: "Canceled",
	Declined: "Declined",
} as const;

export type GetApiAssetsadvertAdvertisementsParams = {
	/**
	 * AssetsCategory id
	 */
	AssetsCategoryId?: number;
	/**
	 * Gets or sets the region.
	 */
	RegionId?: number;
	/**
	 * Gets or sets the identifier.
	 */
	Id?: number;
	/**
	 * Filter out AssetsAdverts with price less or eqaul to this property AdFrameApi.Domain.Models.Assets.AssetsAdvert.Price
	 */
	Price?: number;
	/**
	 * Značka vozu
	 */
	"DetailCategoryFilter.Znacka"?: string;
	/**
	 * Rok výroby od roku
	 */
	"DetailCategoryFilter.RokVyrobyOd"?: number;
	/**
	 * Převodovka
	 */
	"DetailCategoryFilter.Prevodovka"?: string;
	/**
	 * Najeté kilometry do
	 */
	"DetailCategoryFilter.NajetoDo"?: number;
	/**
	 * Palivo
	 */
	"DetailCategoryFilter.Palivo"?: string;
	/**
	 * The sorting option for the advertisements (default is alphabetical ascending).
	 */
	sort?: AdvertisementSort;
	/**
	 * The page number for pagination (default is 0).
	 */
	page?: number;
	/**
	 * The number of items per page (default is 25).
	 */
	pageSize?: number;
};

export type GetApiAssetsadvertMapParams = {
	/**
	 * AssetsCategory id
	 */
	AssetsCategoryId?: number;
	/**
	 * Gets or sets the region.
	 */
	RegionId?: number;
	/**
	 * Gets or sets the identifier.
	 */
	Id?: number;
	/**
	 * Filter out AssetsAdverts with price less or eqaul to this property AdFrameApi.Domain.Models.Assets.AssetsAdvert.Price
	 */
	Price?: number;
	/**
	 * Značka vozu
	 */
	"DetailCategoryFilter.Znacka"?: string;
	/**
	 * Rok výroby od roku
	 */
	"DetailCategoryFilter.RokVyrobyOd"?: number;
	/**
	 * Převodovka
	 */
	"DetailCategoryFilter.Prevodovka"?: string;
	/**
	 * Najeté kilometry do
	 */
	"DetailCategoryFilter.NajetoDo"?: number;
	/**
	 * Palivo
	 */
	"DetailCategoryFilter.Palivo"?: string;
};

export type GetApiAssetsadvertMap200 = { [key: string]: number };
